import React from 'react';
import {PoliciesControllerProps} from '../../../types/checkoutApp.types';
import {WidgetProps} from '@wix/yoshi-flow-editor';

type VoidReturn<T> = T extends (...args: infer P) => unknown ? (...args: P) => void : T;
type VoidMethodsDeep<T extends Record<string, unknown>> = {
  [K in keyof T]: T[K] extends Record<string, unknown> ? VoidMethodsDeep<T[K]> : VoidReturn<T[K]>;
};
export type UsePoliciesControllerPropsResult = WidgetProps<VoidMethodsDeep<PoliciesControllerProps>>;

const Context = React.createContext({} as WidgetProps<PoliciesControllerProps>);

// istanbul ignore next
export function usePoliciesControllerProps(): UsePoliciesControllerPropsResult {
  return React.useContext(Context);
}

export function PoliciesControllerContext({
  value,
  children,
}: {
  value: WidgetProps<PoliciesControllerProps>;
  children: React.ReactNode;
}) {
  return <Context.Provider value={value}>{children}</Context.Provider>;
}
